import { Flip, toast } from "react-toastify";

export const Notification = (type, message) => {
  if (type === "error") {
    toast.error(message, {
      autoClose: 1500,
      position: "top-right",
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      newestOnTop: true,
      pauseOnVisibilityChange: true,
      pauseOnHover: true,
      transition: Flip,
    });
  } else if (type === "success") {
    toast.success(message, {
      autoClose: 1500,
      position: "top-right",
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      newestOnTop: true,
      pauseOnVisibilityChange: true,
      pauseOnHover: true,
      transition: Flip,
    });
  } else if (type === "info") {
    toast.info(message, {
      autoClose: 1500,
      position: "top-right",
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      newestOnTop: true,
      pauseOnVisibilityChange: true,
      pauseOnHover: true,
      transition: Flip,
    });
  } else if (type === "warning") {
    toast.warn(message, {
      autoClose: 1500,
      position: "top-right",
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      newestOnTop: true,
      pauseOnVisibilityChange: true,
      pauseOnHover: true,
      transition: Flip,
    });
  }
};
